(() => {
  class ComboController {
    constructor($scope, ngDialog, toastr, QuestionnaireService, ComboQuestionService) {
      'ngInject';

      Object.assign(this, {
        $scope,
        ngDialog,
        toastr,
        QuestionnaireService,
        ComboQuestionService,
        expression: '',
        comboQuestionStatus: '',
      });
    }

    formatComboMappings(answers) {
      const {expressionText} = this.ComboQuestionService.formatMappingAnswers(answers)
      this.expression = expressionText
    }

    shortenText(text, maxLength) {
      if (text.length <= maxLength) {
        return text;
      } else {
        return text.substring(0, maxLength - 3) + '...';
      }
    }

    saveAnswer(question, editing) {
      const {expressionIds} = this.ComboQuestionService.formatMappingAnswers(question.answers)
      const expressionVal = expressionIds.match(/\b\w+\b/g).filter(value => value !== 'and')
      const status = Number(this.comboQuestionStatus);

      if (!expressionVal.length) {
        this.toastr.warning("Please select answer combinations");
        return
      }

      if (!expressionIds) {
        this.toastr.warning("Please select answer combinations");
        return;
      }
      if (!this.comboQuestionStatus) {
        this.toastr.warning("Please select status");
        return;
      }
      if (editing) {
        const newExpression = {
          data : {
            type: 'answermappings',
            attributes: {
              question_id: question.id,
              expression: expressionIds,
              status
            }
          }}
        this.ngDialog.closeAll({ prevCombination: this.oldCombination, newExpression, question })
      } else {
        const expression = {
          data : {
            type: 'answermappings',
            attributes: {
              question_id: question.id,
              expression: expressionIds,
              status
            }
          }}
        this.ngDialog.closeAll(expression)
      }
    }
  }

  ComboController.$inject = ["$scope", "ngDialog", "toastr", "QuestionnaireService", "ComboQuestionService"]

  angular.module('pims').controller('ComboController', ComboController);
})();
